import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  logout: () => __(translations.navigation.logout, 'Sign-out'),
  profile: () => __(translations.navigation.profile, 'Profile'),
  settings: () => __(translations.navigation.settings, 'Settings'),
  viewAll: () => __(translations.navigation.viewAll, 'View all'),
};
